module.exports = __webpack_public_path__ + "static/media/custom-software-systems.48d8eb70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/custom-software-systems.svg
// module id = 330
// module chunks = 0